export default __webpack_public_path__ + "static/media/whiteTcgPowertools.268eaf96.png";